import React, { Component } from "react";

import moment from 'moment';
import 'moment/locale/pt-br';
import { getLoggedInUser } from "../../helpers/authUtils";
import './rowmensagens.scss';

const RowMensagens = ({ id_medico, profissional, data, mensagens, openImagens }) => {
 
        const renderBalao = (msg, idx) => {
            return (
                <div key={idx} className={(id_medico === msg.usuario.id)?"gb-cont-mensagem-balao right":"gb-cont-mensagem-balao"}>
                    <div className="gb-mensagem-balao">
                        <div style={{ flexDirection: 'row', display: 'flex', justifyContent: (id_medico === msg.usuario.id) ? 'flex-end' : 'flex-start' }}>
                            {(id_medico === msg.usuario.id) ? null : <div>
                                {(msg.tipo_envio === 'whatsapp') ? <abbr style={{ color: '#AAA', fontSize: 12 }} title="Mensagem enviada pelo WhatsApp"><i className="fab fa-whatsapp" style={{ fontSize: 33, color: '#25D366', marginRight: 15 }}></i></abbr> : null}
                            </div>}
                            <div>
                                <strong>{msg.usuario.nome}</strong>
                            </div>
                            {(id_medico === msg.usuario.id) ? <div>
                                {(msg.tipo_envio === 'whatsapp') ? <abbr style={{ color: '#AAA', fontSize: 12 }} title="Mensagem enviada pelo WhatsApp"><i className="fab fa-whatsapp" style={{ fontSize: 33, color: '#25D366', marginLeft: 15 }}></i></abbr> : null}
                            </div> : null}
                        </div>
                        <br />

                        {(msg.tipo_mensagem === 'texto') ? msg.mensagem : null}

                        {(msg.tipo_mensagem === 'videocall') ? (
                            <div style={{ textAlign: 'center', color: '#BBB' }}>
                                <i className="fa fa-video" style={{ fontSize: 40 }}></i><br />
                                Encerrou às {msg.data_desligou ? moment(msg.data_desligou.toDate()).format("HH:mm") : null}
                            </div>
                        ) : null}

                        {
                        (msg.tipo_mensagem === 'imagem') ? (
                            <img
                                style={{ width: "150px", height: "150px", cursor: "pointer", objectFit: 'contain' }}
                                src={msg.mensagem}
                                alt="new"
                                className="img-fluid"
                                onClick={() => openImagens([{ src: msg.mensagem }], 0 )}
                            />
                        ) : null}
                        <div style={{ flexDirection: 'row', display: 'flex', justifyContent: (id_medico === msg.usuario.id) ? 'flex-end' : 'flex-start' }}>
                            <abbr className="gb-mensagem-horario" title={moment(msg.data_envio.toDate()).format("DD/MM/YYYY HH:mm")}>
                                {moment(msg.data_envio.toDate()).format("HH:mm")}
                            </abbr>
                        </div>
                    </div>
                </div>
            )
        }


        return (
                
            <div className="row">
                <div className="col-sm-12">
                    <div className="gb-card mb-3">
                        <div className={getLoggedInUser().username === profissional?"gb-card-header profissional":"gb-card-header"}>
                            <p>{profissional}</p>
                            <span className="gb-card-header-hora">
                                {data}
                            </span>
                        </div>
                        <div className="gb-card-body mensagem">
                            {mensagens.map((msg, idx) => {
                                return renderBalao(msg, idx)
                            })}
                        </div>
                    </div>
                </div>
            </div>
        );
    
}

export default RowMensagens;